import { useState } from "react";
import { useParams } from "react-router-dom";

import { Accordion } from "react-bootstrap";

import CustomButton from "../../kits/button/CustomButton";
import useAxios from "../../../services/useAxios";
import ToastCustomize from "../../kits/ToastCustomize";

import DefineAttribute from "./DefineAttribute";
import AttributeList from "./AttributeList";

import FormulationListDefine from "../formulation-tab/FormulationListDefine";
import { convertFormulToShow } from "../../../utils/helperFunction";

export default function Index({
  changeAttributeData,
  data,
  addPropertyFunc,
  attributeProductList,
  formulationList,
  setFormulationList,
  deactivatePropertyFunc,
  addOrEdit,
  attributeListReactSelect,
  mainTypeProduct,
  setProductListUpdater,
}) {
  const { productId } = useParams();
  const { execute: updateProducts } = useAxios("api/Update_Products");

  const [mathPreview, setMathPreview] = useState("");
  const [enterFormul, setEnterFormul] = useState([]);

  const updateProduct = (id, value) => {
    let tempValue = value[0]?.formulationList?.map((v) => v.value);
    tempValue = tempValue.join().replaceAll(",", " ");
    updateProducts({
      conditions: `id/=/${id}`,
      keyvalues: `inventory_formul,${tempValue}`,
    }).then((res) => {
      if (res.status == 1) {
        setProductListUpdater((prev) => !prev);
        ToastCustomize({
          mainText: "با موفقیت اضافه شد",
          duration: 3000,
          toastType: "success",
          color: "success",
          position: "top-center",
          hasHeader: false,
        });
        setMathPreview("");
        setEnterFormul([]);
        setFormulationList([]);
      } else {
        ToastCustomize({
          mainText: "متاسفانه مشکلی پیش آمده است",
          duration: 3000,
          toastType: "danger",
          color: "danger",
          position: "top-center",
          hasHeader: false,
        });
      }
    });
  };
  console.log("attributeProductList", mathPreview, enterFormul);
  return (
    <div className="attribute-product">
      {mainTypeProduct == 3 && (
        <div className=" my-2 mx-auto" style={{ width: "95%" }}>
          <Accordion>
            <Accordion.Header> افزودن فرمول مصرفی</Accordion.Header>
            <Accordion.Body>
              <div className="col-12 col-sm-6 mt-2 mx-auto ">
                {addOrEdit != "edit" ? (
                  <FormulationListDefine
                    hasLimit={true}
                    limitCount={"1"}
                    compareOperator={true}
                    enterFormul={enterFormul}
                    mathPreview={mathPreview}
                    title="فرمول محاسبه مصرفی"
                    setEnterFormul={setEnterFormul}
                    setMathPreview={setMathPreview}
                    formulationList={formulationList}
                    setFormulationList={setFormulationList}
                    attributeProductList={attributeListReactSelect}
                  />
                ) : (
                  <div
                    className="h-100 d-flex  align-items-center ms-2"
                    style={{ fontSize: 14 }}
                  >
                    <h5>فرمول محاسبه مصرفی:</h5>
                    <p dir="ltr" className="ms-2">
                      {/* {data?.inventory_formul} */}
                    </p>
                  </div>
                )}
              </div>
              <div className="mt-3">
                فرمول مصرفی وارد شده:
                {data.inventory_formul != ""
                  ? convertFormulToShow(
                      data.inventory_formul ?? "",
                      attributeProductList ?? []
                    )
                  : "---"}
              </div>
              <div className="d-flex justify-content-end pe-4">
                <CustomButton
                  color="success"
                  size="medium"
                  //   type="outline"

                  state="normal"
                  circle={false}
                  onClick={(e) => {
                    updateProduct(productId, formulationList);
                  }}
                >
                  ثبت
                </CustomButton>
              </div>
            </Accordion.Body>
          </Accordion>
        </div>
      )}

      <div style={{ width: "95%" }} className="mx-auto">
        <Accordion>
          <Accordion.Header> تعریف صفت</Accordion.Header>
          <Accordion.Body>
            <DefineAttribute
              changeAttributeData={changeAttributeData}
              data={data}
              addPropertyFunc={addPropertyFunc}
            />
          </Accordion.Body>
        </Accordion>
      </div>
      {attributeProductList.length > 0 && (
        <div style={{ width: "92%" }} className="mx-auto mt-4">
          <h5 style={{ fontSize: 15, fontWeight: "bold" }} className="mb-2">
            لیست صفتها
          </h5>
          <AttributeList
            attributeProductList={attributeProductList}
            deactivatePropertyFunc={deactivatePropertyFunc}
          />
        </div>
      )}
    </div>
  );
}
